import {
	ChangeDetectionStrategy,
	Component,
	computed,
	inject,
	input,
} from '@angular/core';
import { PercentToValuePipe } from '@marmon/frontend/common';
import {
	CellColorCode,
	ColorCodeCellBase,
} from './color-code-cell-base.component';
import { PercentileCalculation } from '@marmon/shared/types/analysis';

@Component({
	standalone: true,
	providers: [PercentToValuePipe],
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'mar-percent-of-eighty-cell',
	templateUrl: 'color-code-cell.component.html',
	host: { class: 'flex gap-2 items-center' },
})
export class PercentOfEightyCellComponent extends ColorCodeCellBase<number> {
	readonly toValue = inject(PercentToValuePipe);
	readonly percentiles = input.required<PercentileCalculation | null>();

	override readonly formattedValue = computed(() => {
		let value = this.value();
		if (value === undefined) value = 0;
		return this.toValue.transform(value);
	});

	override getColorCode(value: number): CellColorCode {
		const percentiles = this.percentiles();
		if (!percentiles) return 'gray';

		if (value >= percentiles[80]) return 'green';
		if (value >= percentiles[40]) return 'yellow';
		return 'red';
	}
}
